/* eslint-disable no-use-before-define */
import React from 'react'
import { $, Loading, hideModal, Fields, } from '../../twd'
import useHoldingModals from './use-holdings-modal'
import Grid from './grid'

export default ({acctNo}) => {

    const {
        status, accounts, holdings,
        account, setAccount,
    } = useHoldingModals({acctNo})

    React.useEffect(() => {
        setTimeout(() => {
            $('#modal :focusable').eq(0).focus()
        }, 200)
    }, [status])

    return <React.Fragment>
    <div
        data-name="holdings-modal"
        className="modal-dialog modal-lg">
    <div className="modal-content">
        <div className="modal-header">
            <button
                data-name="holdings-modal-close"
                className="close"
                aria-label="close"
                type="button"
                onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h2 className="modal-title text-center vertical-offset-sm">Holdings</h2>

            <div className="container">
            <Loading status={status}>

                <div className="row vertical-offset-base">
                    <Select account={account} accounts={accounts} setAccount={setAccount} />
                </div>


                <div className="row">
                <div className="col-md-12 text-left" style={{
                    background: '#ffffff',
                    border: 'solid 1px #e4e4e4',
                    padding: '10px',
                    maxHeight: '300px',
                    overflowY: 'auto',
                }}>
                <Grid holdings={holdings} account={account} />
                </div>
                </div>
            </Loading>
            </div>
        </div>


        <div className="modal-footer">
        <div className="row">
        <div className='col-md-4'></div>
        <div className='col-md-4'>
            <button
                data-name="holdings-modal-close-button"
                className="btn btn-block btn-primary"
                type="button"
                onClick={hideModal}
            >Close</button>
        </div>
        <div className='col-md-4'></div>
        </div>
        </div>
    </div>
    </div>

    </React.Fragment>
}

const Select = ({account, accounts, setAccount}) => {
    return <React.Fragment>
    <div className="col-md-2 col-xs"></div>
    <div className="col-md-8 col-xs-12 from-group"
        style={{paddingLeft:'0px', paddingRight:'0px'}}
    >
        <Fields.SelectMulti
            dataName="header-holdings-modal-account"
            label={<label className="label">Account</label>}

            emptyText=''
            allText=''

            showSelectAll={false}
            isMultiSelect={false}

            options={ accounts.map(a => ({ label:a.title, value:a.acctNo, })) }
            style={{marginBottom:'0px'}}
            optionCheckboxLabelConfig={{
                className:"text-truncate",
            }}

            placeholder={({emptyText, allText, values, options}) => {
                const a = options.filter(({value}) => value===account)[0]
                return (a && a.label) || emptyText
            }}

            onSelect={(acct) => {
                setAccount(acct.value)
            }}
        />
    </div>
    <div className="col-md-2 col-xs"></div>
    </React.Fragment>
}